import styles from "./Footer.module.css";
import ContactRow from "../UI/ContactRow";
import phoneIcon from "../../assets/navigation/phone-icon-colored.png";
import mailIcon from "../../assets/navigation/mail-icon-colored.png";
import locationIcon from "../../assets/navigation/location-icon.png";
import { useContext } from "react";
import DataContext from "../store/data-context";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import NavigationContext from "../store/navigation-context";

export default function Footer() {
  const dataCtx = useContext(DataContext);
  const navCtx = useContext(NavigationContext);

  const mainColumnHR = [
    {
      name: dataCtx.pageData.about_us.title,
      href: `/${dataCtx.lang.lang}#about_us`,
    },
    { name: "kontakt", href: "#contact" },
    { name: "katalozi", href: "#catalogue" },
    { name: "partneri", href: `/${dataCtx.lang.lang}#partners` },
    { name: "oglasnik", href: "/market" },
  ];

  return (
    <main className={styles.main}>
      <div className={styles.grid}>
        <div className={styles.column}>
          <HashLink
            to={`/${dataCtx.lang.lang}#about_us`}
            className={styles.element}
          >
            {dataCtx.pageData.about_us.title}
          </HashLink>

          <div
            onClick={() => {
              navCtx.setIsContacting(true);
            }}
            className={styles.element}
          >
            {dataCtx.pageData.contact.title}
          </div>

          <HashLink
            to={`/${dataCtx.lang.lang}#catalogues`}
            className={styles.element}
          >
            {dataCtx.pageData.categories.nav_title}
          </HashLink>

          <HashLink
            to={`/${dataCtx.lang.lang}#partners`}
            className={styles.element}
          >
            {dataCtx.pageData.partners.title}
          </HashLink>

          <Link
            to={`/${dataCtx.lang.lang}/${dataCtx.pageData.market.title}`}
            className={styles.element}
          >
            {dataCtx.pageData.market.title}
          </Link>
        </div>
        <div className={styles.categories}>
          <div className={styles.column}>
            {dataCtx.categories.map((e, i) => {
              if (i < 5) {
                return (
                  <Link
                    to={`${dataCtx.lang.lang}/${dataCtx.pageData.categories.nav_title}/${e.acf.lang_url}`}
                    key={i}
                    className={styles.element}
                  >
                    {e.post_title}
                  </Link>
                );
              }
            })}
          </div>
          <div className={styles.column}>
            {dataCtx.categories.map((e, i) => {
              if (i >= 5)
                return (
                  <div key={i} className={styles.element}>
                    {e.post_title}
                  </div>
                );
            })}
          </div>
        </div>
        <div className={styles.contacts}>
          <ContactRow isMobile={true} icon={phoneIcon} info="+385 992406888" />
          <ContactRow isMobile={true} icon={mailIcon} info="hogast@hogast.hr" />
          <ContactRow
            isMobile={true}
            icon={locationIcon}
            info="HOGAST D.O.O., Štrigova 134, 
40312 Štrigova"
          />
        </div>
      </div>
      <div className={styles.copyright}>©HoGast</div>
    </main>
  );
}
